var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-tertiary btn-lg preview-button ignore",attrs:{"disabled":_vm.disabled},on:{"click":_vm.preview}},[_c('translation',{attrs:{"text":_vm.lang.get('entries.form.preview')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }